let origin: { tourId: string; element: HTMLElement } | null = null;

export function rememberTourOrigin(tourId: string, element: HTMLElement | null) {
    origin = element ? { tourId, element } : null;
}

export function getTourOrigin(tourId: string): HTMLElement | null {
    if (origin?.tourId === tourId && origin.element.isConnected && origin.element.getClientRects().length) {
        return origin.element;
    }
    return document.querySelector<HTMLElement>('.tour-launcher__button');
}
